"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CancelAPButton = _interopRequireDefault(require("../../common/CancelAPButton"));
var _APTable = _interopRequireDefault(require("../../common/APTable"));
var _dateHelper = require("../../../helpers/dateHelper");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./ScheduledReportsTableComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('schedule-report-list');
var ScheduledReportsTableComponent = function ScheduledReportsTableComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var reports = props.reports,
    isLoading = props.isLoading,
    cancelReport = props.cancelReport;
  var columns = [{
    header: t("Report Summary"),
    classModifier: 'type',
    cell: function cell(row) {
      return row.reportFlavor;
    }
  }, {
    header: t("Frequency"),
    classModifier: 'frequency',
    cell: function cell(row) {
      return row.ReportFrequency;
    }
  }, {
    header: t("Created"),
    classModifier: 'created',
    cell: function cell(row) {
      return (0, _dateHelper.formatDateTime)(row.createTime);
    }
  }, {
    header: t("Actions"),
    classModifier: 'actions',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
        customClass: baseClass('action-btn'),
        styleName: "subtractive",
        text: t("Cancel Report"),
        onClick: function onClick() {
          return cancelReport(row.RequestId);
        }
      });
    }
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('container')
  }, /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    columns: columns,
    baseClass: baseClass,
    rows: reports,
    empty: t("No Report Is Available"),
    fetching: isLoading,
    headerOutside: true
  }));
};
ScheduledReportsTableComponent.propTypes = {
  reports: _propTypes["default"].array.isRequired,
  cancelReport: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ScheduledReportsTableComponent;